import React from 'react';

import { Button, Modal } from '@common/index';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { flowActions } from '@store/slices';
import { AppDispatch, State } from '@store/index';
import { Warning } from '@mui/icons-material';
import { useTheme } from '../../styles/theme';

export const UnsavedChanges: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const theme = useTheme();

  const pathToNavigate = useSelector((state: State) => state.flow.showUnsaved);
  const navigateType = useSelector((state: State) => state.flow.showUnsavedType);
  const open = Boolean(pathToNavigate);
  const setOpen = (val: string | null) => dispatch(flowActions.setShowUnsaved(val));

  const discard = () => {
    if (!open) return;

    closeModal();

    if (navigateType === 'link' && pathToNavigate) {
      window.location.href = pathToNavigate;
    } else {
      navigate(pathToNavigate || '/');
    }
  };

  const closeModal = () => {
    setOpen(null);
    dispatch(flowActions.setShowUnsavedType('path'));
  };

  return (
    <Modal
      open={Boolean(open)}
      onClose={closeModal}
      setOpen={setOpen as (val: boolean | string | null) => void}
      header='Unsaved Changes'
      background={theme.telnyx.orange}
      icon={<Warning />}
      info='You are about to navigate away and there are tabs with unsaved changes in this workspace. Do you want to discard these changes and continue?'
      actions={
        <Stack direction='row' spacing={1}>
          <Button small onClick={closeModal}>
            Cancel
          </Button>
          <Button small customColor='orange' onClick={discard}>
            Discard & Continue
          </Button>
        </Stack>
      }
    />
  );
};
